import { render, staticRenderFns } from "./VtBubble.vue?vue&type=template&id=65ef71ee&"
import script from "./VtBubble.vue?vue&type=script&lang=js&"
export * from "./VtBubble.vue?vue&type=script&lang=js&"
import style0 from "./VtBubble.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports